import { useState, useCallback } from "react";
import { useSensors, useSensor, PointerSensor } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";

export default function usePaletteDnD(items, setItems) {
  const sensors = useSensors(useSensor(PointerSensor));
  const [draggingItem, setDraggingItem] = useState(null);

  const handleDragStart = useCallback(({ active }) => {
    const item = items.find((i) => i.key === active.id);
    setDraggingItem(item);
  }, [items]);

  const handleDragEnd = useCallback(({ active, over }) => {
    if (!over || active.id === over.id) {
      setDraggingItem(null);
      return;
    }
    const oldIndex = items.findIndex((i) => i.key === active.id);
    const newIndex = items.findIndex((i) => i.key === over.id);
    if (oldIndex < 0 || newIndex < 0) return;

    const updated = arrayMove(items, oldIndex, newIndex);
    setItems(updated);
    setDraggingItem(null);
  }, [items, setItems]);

  const handleDragCancel = useCallback(() => setDraggingItem(null), []);

  return {
    sensors,
    draggingItem,
    handleDragStart,
    handleDragEnd,
    handleDragCancel,
  };
}
